import { Injectable } from "@angular/core";
import { NestApiProvider } from "../../nest-api";
import { Observable } from "rxjs";
import {
  RequestShiftDownloadExcelDto,
  RequestShiftDownloadPdfDto,
  RequestShiftSendExcelDto, ResponseShiftSendExcelDto,
  RequestShiftSendPdfDto, ResponseShiftSendPdfDto
} from "../dto/shiftschedule-report.dto";
@Injectable()
export class ShiftReportApi {
  private readonly service: string = '';
  private readonly model: string = 'ShiftReport';
  private timeout: number = (5 * 60) * 1000;

  constructor(
    private readonly nestApiProvider: NestApiProvider,
  ) {
  }

  public downloadExcel(data: RequestShiftDownloadExcelDto) {
    const method: string = 'POST';
    const func: string = 'shiftDownloadExcel';
    const params: RequestShiftDownloadExcelDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.requestBlob(method, url, params, urlParams, body);
  }

  public downloadPdf(data: RequestShiftDownloadPdfDto) {
    const method: string = 'POST';
    const func: string = 'shiftDownloadPdf';
    const params: RequestShiftDownloadPdfDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.requestBlob(method, url, params, urlParams, body);
  }

  reportSendEmailExcel(data: RequestShiftSendExcelDto): Observable<ResponseShiftSendExcelDto> {
    const method: string = 'POST';
    const func: string = 'shiftReportSendEmail';
    const params: RequestShiftSendExcelDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseShiftSendExcelDto>(method, url, params, urlParams, body, null, this.timeout);
  }

  reportSendEmailPdf(data: RequestShiftSendPdfDto): Observable<ResponseShiftSendPdfDto> {
    const method: string = 'POST';
    const func: string = 'shiftReportSendEmailPdf';
    const params: RequestShiftSendPdfDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseShiftSendPdfDto>(method, url, params, urlParams, body, null, this.timeout);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/shiftschedule-report.api.ts